// © Microsoft Corporation. All rights reserved.

// todo: Deliverable 29531401: [Client] Move client-data-settings to a separate library to avoid importing core library
// Remove these and import from common library once the above deliverable is completed.

/**
 * Checks if the DOM is available to access and use.
 * @returns {boolean} - true if DOM is available, or false if it is not. This is typically true for
 * client side rendering and false for server side rendering.
 */
export function canUseDOM(): boolean {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

/**
 * Return true if html has app cache enabled
 */
export function isAppCache() {
    if (canUseDOM() && window.applicationCache) {
        const htmlElement = window.document.getElementsByTagName("html")[0];
        return htmlElement.getAttribute("manifest");
    }

    return false;
}

/**
 * Define a queue to store error list with limit length to track trace of error event
 *
 */
export class LimitQueue<T> {
    maxLength = 20;
    list: T[] = [];
    constructor(length = 20) {
        this.maxLength = length;
    }
    push(payload: T) {
        this.list.push(payload);
        if (this.list.length > this.maxLength) {
            this.list.shift();
        }
    }
    get data(): T[] { return this.list; }
}